import React from "react";
import { useNavigate, useParams } from "react-router-dom";
import { getFloorById, updateFloor } from "adminApi/FloorApi/Floor";
import { validateForm } from "utils/validation";
import { FloorRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import EditFloorForm from "./Components/EditFloorForm";
import fields from "../json/FloorFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";

const EditFloor = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const { formdata } = fields;

    // Build initial values from field definitions
    const initialValues = formdata.reduce((acc, field) => ({ ...acc, [field.name]: "" }), {});

    const { values, errors, handleChange, setValues, setErrors } = useFormChange(
        initialValues,
        FloorRules
    );

    // Fetch existing record by ID and populate form
    const { loading: loadingFetch } = useFetchFormDataById(id, formdata, getFloorById, setValues);

    const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
        // Send plain JSON — no file uploads in this form
        async (formValues) => await updateFloor({ id, data: formValues }),
        (vals) => {
            const err = validateForm(vals, FloorRules);
            setErrors(err);
            return err;
        },
        () => navigate(-1),
        "Floor updated successfully"
    );

    return (
        <>
            {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}
            <EditFloorForm
                fields={formdata}
                values={values}
                errors={errors}
                handleChange={handleChange}
                handleSubmit={(e) => handleSubmit(e, values)}
                loading={loadingSubmit}
                title="Edit Floor"
            />
        </>
    );
};

export default EditFloor;
